export const toUndef = (s?: string | null) => (s?.trim() ? s : undefined);
